import { InstitutionsState } from './types'
import { AsyncStateStatus } from '../root.types'
import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit'

const initialState: InstitutionsState = {
    request: {
        status: AsyncStateStatus.INITIAL,
        org: '',
        data: []
    },
    describe: {
        status: AsyncStateStatus.INITIAL,
        org: 'Carregando...',
        cnpj: 'Carregando...',
        dataEmps: {
            status: AsyncStateStatus.INITIAL,
            total: 0,
            data: []
        },
        dataServidores: [],
        dataBiddings: {
          data: [],
          status: AsyncStateStatus.INITIAL
        },
        dataContracts: {
          data: [],
          status: AsyncStateStatus.INITIAL
        },
        dataAdditives: {
          data: [],
          status: AsyncStateStatus.INITIAL
        },
        dataPayments: {
          data: [],
          status: AsyncStateStatus.INITIAL
        },
        dataPayrollRecords: {
          data: [],
          status: AsyncStateStatus.INITIAL
        },
        notes: {
            status: AsyncStateStatus.INITIAL,
            data: []
        },
        itens: {
            status: AsyncStateStatus.INITIAL,
            data: []
        }
    }
}

export const institutionsSlice = createSlice({
    name: '@institutions',
    initialState,
    reducers: {
        institutionsRequest: (state: Draft<InstitutionsState>) => {
            state.request.status = AsyncStateStatus.LOADING
        },
        institutionsSuccess: (state: Draft<InstitutionsState>,  action: PayloadAction<{ data: any }>) => {
            state.request.status = AsyncStateStatus.SUCCESS
            state.request.data = action.payload.data
        },
        institutionsFailure: (state: Draft<InstitutionsState>) => {
            state.request.status = AsyncStateStatus.FAILURE
            state.request.data = []
        },
        describeRequest: (state: Draft<InstitutionsState>) => {
            state.describe.status = AsyncStateStatus.LOADING
            state.describe.org = initialState.describe.org
            state.describe.cnpj = initialState.describe.cnpj
        },
        describeSuccess: (state: Draft<InstitutionsState>,  action: PayloadAction<{ data: any }>) => {
            state.describe.status = AsyncStateStatus.SUCCESS
            state.describe.org = action.payload.data.org
            state.describe.cnpj = action.payload.data.cnpj
        },
        describeFailure: (state: Draft<InstitutionsState>) => {
            state.describe.status = AsyncStateStatus.FAILURE
            state.describe.org = 'Não econtrado.'
            state.describe.org = 'Não econtrado.'
        },
        empsRequest: (state: Draft<InstitutionsState>) => {
            state.describe.dataEmps.status = AsyncStateStatus.LOADING
        },
        empsSuccess: (state: Draft<InstitutionsState>,  action: PayloadAction<{ data: any }>) => {
            state.describe.dataEmps.status = AsyncStateStatus.SUCCESS
            state.describe.dataEmps.data = action.payload.data.dataEmps.data
            state.describe.dataEmps.total = action.payload.data.dataEmps.total
        },
        empsFailure: (state: Draft<InstitutionsState>) => {
            state.describe.dataEmps.status = AsyncStateStatus.FAILURE
        },
        notesRequest: (state: Draft<InstitutionsState>) => {
            state.describe.notes.status = AsyncStateStatus.LOADING
        },
        notesRequestSuccess: (state: Draft<InstitutionsState>, action: PayloadAction<{ data: any }>) => {
            state.describe.notes.status = AsyncStateStatus.SUCCESS
            state.describe.notes.data = action.payload.data
        },
        notesRequestFailure: (state: Draft<InstitutionsState>) => {
            state.describe.notes.status = AsyncStateStatus.FAILURE
        },
        itensNotesRequest: (state: Draft<InstitutionsState>) => {
            state.describe.itens.status = AsyncStateStatus.LOADING
        },
        itensNotesSuccess: (state: Draft<InstitutionsState>, action: PayloadAction<{ data: any }>) => {
            state.describe.itens.status = AsyncStateStatus.SUCCESS
            state.describe.itens.data = action.payload.data
        },
        itensNotesFailure: (state: Draft<InstitutionsState>) => {
            state.describe.itens.status = AsyncStateStatus.FAILURE
        },
        biddingsRequest: (state: Draft<InstitutionsState>) => {
            state.describe.dataBiddings.status = AsyncStateStatus.LOADING
        },
        biddingsSuccess: (state: Draft<InstitutionsState>, action: PayloadAction<{ data: any }>) => {
            state.describe.dataBiddings.status = AsyncStateStatus.SUCCESS
            state.describe.dataBiddings.data = action.payload.data
        },
        biddingsFailure: (state: Draft<InstitutionsState>) => {
            state.describe.dataBiddings.status = AsyncStateStatus.FAILURE
        },
        contractsRequest: (state: Draft<InstitutionsState>) => {
            state.describe.dataContracts.status = AsyncStateStatus.LOADING
        },
        contractsSuccess: (state: Draft<InstitutionsState>, action: PayloadAction<{ data: any }>) => {
            state.describe.dataContracts.status = AsyncStateStatus.SUCCESS
            state.describe.dataContracts.data = action.payload.data
        },
        contractsFailure: (state: Draft<InstitutionsState>) => {
            state.describe.dataContracts.status = AsyncStateStatus.FAILURE
        },
        additivesRequest: (state: Draft<InstitutionsState>) => {
            state.describe.dataAdditives.status = AsyncStateStatus.LOADING
        },
        additivesSuccess: (state: Draft<InstitutionsState>, action: PayloadAction<{ data: any }>) => {
            state.describe.dataAdditives.status = AsyncStateStatus.SUCCESS
            state.describe.dataAdditives.data = action.payload.data
        },
        additivesFailure: (state: Draft<InstitutionsState>) => {
            state.describe.dataAdditives.status = AsyncStateStatus.FAILURE
        },
        paymentsRequest: (state: Draft<InstitutionsState>) => {
            state.describe.dataPayments.status = AsyncStateStatus.LOADING
        },
        paymentsSuccess: (state: Draft<InstitutionsState>, action: PayloadAction<{ data: any }>) => {
            state.describe.dataPayments.status = AsyncStateStatus.SUCCESS
            state.describe.dataPayments.data = action.payload.data
        },
        paymentsFailure: (state: Draft<InstitutionsState>) => {
            state.describe.dataPayments.status = AsyncStateStatus.FAILURE
        },
        payrollrecordRequest: (state: Draft<InstitutionsState>) => {
            state.describe.dataPayrollRecords.status = AsyncStateStatus.LOADING
        },
        payrollrecordSuccess: (state: Draft<InstitutionsState>, action: PayloadAction<{ data: any }>) => {
            state.describe.dataPayrollRecords.status = AsyncStateStatus.SUCCESS
            state.describe.dataPayrollRecords.data = action.payload.data
        },
        payrollrecordFailure: (state: Draft<InstitutionsState>) => {
            state.describe.dataPayrollRecords.status = AsyncStateStatus.FAILURE
        },
    }
})

/**
 * <h5>Functions that trigger actions related to authentication in the system.</h5>
 * @see {@link https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers#designing-actions}
 * @typedef InstitutionsActions
 * @namespace InstitutionsActions
 * @category React
 * @subcategory Redux / Actions
 * @property {Function} institutionsRequest
 * @property {Function} institutionsSuccess
 * @property {Function} institutionsFailure
 * @property {Function} describeRequest
 * @property {Function} describeSuccess
 * @property {Function} describeFailure
 * @property {Function} empsRequest
 * @property {Function} empsSuccess
 * @property {Function} empsFailure
 */
export const InstitutionsActions = institutionsSlice.actions

export default institutionsSlice.reducer
